import { fetchy } from '@bridebook/web/lib/fetchy';
import type { TrackEventBody, TrackEventBodyWeb } from '@bridebook/toolbox/src/types';
import type { IApplicationState } from '@bridebook/web/lib/types';
import getServerSideAnalyticsProps from '@bridebook/web/lib/utils/get-server-side-analytics-props';

interface IReviewServerSideTrack extends TrackEventBody {
  state: IApplicationState;
  event: string;
  identifyProps?: Record<string, any>;
  specificEventProps: Record<string, any>;
  viewedSupplierId: string;
  category: string;
}

const reviewTrack = ({
  state,
  event,
  identifyProps,
  specificEventProps,
  viewedSupplierId,
  category = '',
}: IReviewServerSideTrack) => {
  const body: TrackEventBodyWeb = {
    event,
    identifyProps,
    genericProps: getServerSideAnalyticsProps(state),
    specificEventProps,
    source: 'web',
    viewedSupplierId,
    category,
  };

  return fetchy().post('/api/a/t/review', null, body);
};

export default reviewTrack;
